import Button from '@carvana/ds-button';
import React from 'react';
import styles from './support-contact.module.css';
import useSupportContactClick from './use-support-contact-click';

interface SupportContactProps {
  onClick: () => void;
  onClose?: () => void;
}

const SupportContact: React.FC<SupportContactProps> = ({ onClick, onClose }) => {
  const handleClick = useSupportContactClick({ onClick, onClose });

  return (
    <Button
      variant="primary"
      size="xs"
      onClick={handleClick}
      className={styles.supportButton}
      data-analytics-id="pp_header_support_contact"
    >
      <span className={styles.supportText}>Support & Contact</span>
    </Button>
  );
};

export default SupportContact;
